var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedHovericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2320_10141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75793,
    y: 5.02368,
    width: 32.726,
    height: 33.8643,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0938 2.75H3.65653C2.12438 2.75 0.879517 3.99609 0.879517 5.52578V38.4742C0.879517 40.0039 2.12438 41.25 3.65653 41.25H37.0938C38.6259 41.25 39.8795 40.0039 39.8795 38.4742V5.52578C39.8795 3.99609 38.6259 2.75 37.0938 2.75ZM12.6666 35.75V35.75C9.47417 35.75 6.88621 33.162 6.88621 29.9696V20.2711C6.88621 18.6725 8.18214 17.3766 9.78074 17.3766V17.3766C11.3794 17.3766 12.6753 18.6725 12.6753 20.2711V35.7413C12.6753 35.7461 12.6714 35.75 12.6666 35.75V35.75ZM9.77639 14.8672C7.92215 14.8672 6.42483 13.3805 6.42483 11.5586C6.42483 9.73672 7.92215 8.25 9.77639 8.25C11.6219 8.25 13.128 9.73672 13.128 11.5586C13.128 13.3891 11.6306 14.8672 9.77639 14.8672ZM34.3342 32.8598C34.3342 34.456 33.0402 35.75 31.444 35.75V35.75C29.8478 35.75 28.5538 34.456 28.5538 32.8598V26.8125C28.5538 24.6813 28.5103 21.9398 25.5505 21.9398C22.5384 21.9398 22.0771 24.2602 22.0771 26.6578V32.8598C22.0771 34.456 20.7831 35.75 19.1869 35.75V35.75C17.5907 35.75 16.2967 34.456 16.2967 32.8598V20.1492C16.2967 18.6179 17.5381 17.3766 19.0694 17.3766H20.5873C21.2803 17.3766 21.842 17.9383 21.842 18.6312V19.8369C21.842 19.864 21.864 19.8859 21.891 19.8859V19.8859C21.9091 19.8859 21.9255 19.8762 21.9342 19.8604C22.7175 18.4243 24.6008 16.9211 27.396 16.9211C33.246 16.9211 34.3342 20.7281 34.3342 25.6781V32.8598Z",
    fill: "url(#paint0_linear_2320_10141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2320_10141",
    x1: 10.7557,
    y1: -2.31818,
    x2: 47.3045,
    y2: 29.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2320_10141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 44,
    fill: "white",
    transform: "translate(0.879517)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedHovericon);
export default __webpack_public_path__ + "static/media/linkedHovericon.9589e05634413a313f950a771451b688.svg";
export { ForwardRef as ReactComponent };